export default "__VITE_ASSET__Cpcz4JwM__"